/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_AddInputs */

const vi_grower_area_camera_add = /** @type {(inputs: Grower_Area_Camera_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm camera`)
};

/**

* @param {Grower_Area_Camera_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_add = /** @type {((inputs?: Grower_Area_Camera_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_add(inputs)
});